import styled from 'styled-components';

export const StyledLineFeeParagraph = styled.p`
  display: inline-block;
  line-height: ${({ theme }) => theme.spacing.space_5};
  margin-right: ${({ theme }) => theme.spacing.space_4};
  margin-bottom: 0;
`;
